import React, { } from 'react';

import 'moment/locale/ru';
import { Action, JSXMap, useAuth, useUserContext, ycStorage } from 'fennec-ui';
import moment from 'moment-timezone';
import YImage from '../../../common/YImage';
import { eventRoleAdministrator, eventRoleChlenKomitetaPoSudeistvu, eventRoleControler, eventRoleDJ, eventRoleDancer, eventRoleJudge, eventRoleMainJudge, eventRoleOperatorOBS, eventRoleOrganizer, eventRolePresenter, eventRoleSpecialguest, eventRoleViewer, ycBucket } from '../../../common/Tool';
import QRCode from 'react-qr-code';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useLocation } from 'react-router';
import Icofont from 'react-icofont';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');
var _ = require('lodash');

export default function EventListItem(props) {
    const { event: e, size, buttons, extend, style, qr, tickets, eventUsers, adminButton, extButtons, content, hideRoles, hideKategorii, hidePreview, noNameLink, hideBuyButton, hideDetailButton, imageSize } = props;
    const auth = useAuth();
    const user = useUserContext();

    const sameDay = (start, end) => {
        var mstart = moment(start);
        var mend = moment(end);
        var year1 = mstart.year(), month1 = mstart.month(), day1 = mstart.date();
        var day1n = mstart.add(24, 'hour')
        var year2 = mend.year(), month2 = mend.month(), day2 = mend.date();
        var hour2 = mend.hour();
        if (year1 === year2 && month1 === month2 && ((day2 === day1) || (day2 === day1n && hour2 < 8))) {
            return true
        }
        return false
    };
    const org = (item) => {
        if (item && item.organizatorFederatsiya) {
            return "Федерация"
        } else if (item && item.organizatorRegionalnoeOtdelenie) {
            return item.organizatorRegionalnoeOtdelenie.nazvanie;
        } else if (item && item.organizatorMeropriyatiya) {
            return item.organizatorMeropriyatiya.nazvanie;
        } else if (item && item.organizatorShkola) {
            return item.organizatorShkola.nazvanieShkoliTantsev;
        }
    }
    const _image = (item) => {
        if (item && item.ssilkiNaFailiMeropriyatie && item.ssilkiNaFailiMeropriyatie.length) {
            return ycStorage(auth) + ycBucket(auth) + "/" + _.head(item.ssilkiNaFailiMeropriyatie).ssilka
        }
        return "error";
    }
    const kategorii = (data) => {
        let result = [];
        let mResult = new Map();
        if (data) {
            for (let idx = 0; idx < data.length; idx++) {
                const item = data[idx];
                let kat = mResult.get(item.tantsevalnayaDistsiplinaID);
                if (!kat) {
                    kat = {
                        tantsevalnayaDistsiplina: item.tantsevalnayaDistsiplina,
                        kategoriiUchastnikov: [],
                        mKategoriiUchastnikov: new Map(),
                    }
                    mResult.set(item.tantsevalnayaDistsiplinaID, kat);
                    result.push(kat);
                }
                let ok = kat.mKategoriiUchastnikov.get(item.kategoriyaUchastnikovID);
                if (!ok) {
                    kat.mKategoriiUchastnikov.set(item.kategoriyaUchastnikovID, data[idx].kategoriyaUchastnikov)
                    kat.kategoriiUchastnikov.push(data[idx].kategoriyaUchastnikov);
                }
            }
        }

        for (let idx = 0; idx < result.length; idx++) {
            result[idx].kategoriiUchastnikov.sort((a, b) => a.ID - b.ID);
        }

        result.sort((a, b) => a.tantsevalnayaDistsiplina.ID - b.tantsevalnayaDistsiplina.ID);

        return result
    }
    const kategoriiView = (e) => {
        const list = kategorii(e.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie);
        if (list.length <= 0) return <></>;
        return (
            <div key="q0" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                <div>Категории:</div>
                <ul className="dotted" style={{ marginBottom: "7px" }}>
                    {list.map((kat, i) => {
                        return <li key={i}>
                            {kat.tantsevalnayaDistsiplina.nazvanie + " "}
                            ({
                                kat.kategoriiUchastnikov.map((itemD, idx) => {
                                    if (idx + 1 < kat.kategoriiUchastnikov.length) {
                                        return <span key={idx}>{itemD.nazvanie + ", "}</span>
                                    } else {
                                        return <span key={idx}>{itemD.nazvanie}</span>
                                    }
                                })
                            })
                        </li>
                    })}
                </ul>
            </div>
        );
    };

    const { pathname } = useLocation();
    const path = (pathname, pop = 0) => {
        let fpath = _.trimEnd(pathname, '/');
        let path = fpath.split("/");
        if (path.length - 1 >= pop) {
            for (let i = 0; i < pop; i++) {
                path.pop();
            }
        }
        let l = path.join("/")
        return l
    }

    const imgSize = (size === "medium" || size === "small") ? imageSize || 78 : imageSize || 195;
    return (
        <div style={{
            padding: "5px",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
        }}>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                // justifyContent: "flex-start",
                flexDirection: (size !== "medium" && size !== "small") ? "column" : "row",

                borderRadius: "6px",
                flex: "1 1 auto",
                border: (size === "medium" || size === "small") ? "1px solid rgba(0,0,0,0.08)" : "transparent",
                padding: (size === "medium" || size === "small") ? "5px 7px" : undefined
            }}>
                <div style={{ maxWidth: (size === "medium" || size === "small") ? undefined : `${imgSize}px`, display: "flex", justifyContent: "flex-start", flexDirection: "column", alignSelf: (size === "medium" || size === "small") ? "left" : "center" }}>
                    {(size !== "small") && <div style={{ width: `${imgSize}px`, height: `${imgSize}px`, overflow: "hidden", borderRadius: "4px" }}>
                        <YImage item={e} width={imgSize} hidePreview={hidePreview} />
                    </div>}
                    <div style={{ marginTop: (size === "medium" || size === "small") ? (size === "small") ? "2px" : "5px" : "7px" }}>
                        <div style={{
                            backgroundColor: "#eaeaea",
                            fontSize: (size === "medium" || size === "small") ? "14px" : "16px",
                            fontWeight: "400",
                            color: "black",
                            borderRadius: "6px",
                            textAlign: "center",
                            padding: "0 7px",
                            textAlign: "center",
                        }}>
                            <div style={{
                                borderRadius: "5px",
                                backgroundColor: (moment(e.nachaloSorevnovaniya) < moment()) ? "rgb(145 145 145)" : "#f6214b",

                                lineHeight: "18px",
                                fontSize: (size === "medium" || size === "small") ? "12px" : "14px",
                                fontWeight: "600",
                                color: "white",
                                margin: "0 -7px",
                                boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
                                padding: "3px 7px"
                            }}>
                                {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
                                {/* {true === sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) &&
                                    moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')
                                }
                                {true !== sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) &&
                                    <>
                                        <div style={{ fontSize: (size === "medium" || size === "small") ? "14px" : "16px" }}>
                                            {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD')}
                                            -
                                            {moment(e.okonchanieSorevnovaniya).tz("Europe/Moscow").format('DD')}
                                        </div>
                                        <div style={{ fontSize: (size === "medium" || size === "small") ? "12px" : "14px" }}>
                                            {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('MMMM')} {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('YYYY')}
                                        </div>
                                    </>
                                } */}
                            </div>
                            <div style={{
                                fontSize: (size === "medium" || size === "small") ? "10px" : "11px",
                                fontWeight: "400",
                                padding: "0px"
                            }}>
                                {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                {/* {true === sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) && <>
                                    {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                </>}
                                {true !== sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) && <>
                                    {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                    <span> - </span>
                                    {moment(e.okonchanieSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                </>} */}
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{
                    flex: "auto", paddingLeft: (size === "medium" || size === "small") ? "9px" : "7px", paddingRight: (size === "small") ? "5px" : "7px", textAlign: "left"
                }}>

                    <div key="q1" style={{
                        textOverflow: "initial",
                        whiteSpace: "normal",
                        marginTop: "0px",
                        lineHeight: (size === "medium" || size === "small") ? "16px" : "inherit",
                        fontSize: (size === "medium" || size === "small") ? "14px" : "22px",
                        padding: (size !== "medium" && size !== "small") ? "10px 0" : "0px",
                        textAlign: (size !== "medium" && size !== "small") ? "center" : "left",
                    }}>
                        {!noNameLink && <a href={`/fed/event/${e.ID}`}>
                            <span style={{ fontWeight: "600" }}>{e.nazvanieMeropriyatiya}</span>
                        </a>}
                        {noNameLink && <span style={{ fontWeight: "600" }}>{e.nazvanieMeropriyatiya}</span>}
                    </div>
                    {(size !== "small" && e?.meropriyatieNaFestivaleMeropriyatie?.length > 0) &&
                        <div>
                            <span>Фестивали: </span>
                            {JSXMap(e.meropriyatieNaFestivaleMeropriyatie, (itemD) => {
                                return (
                                    <a key={itemD.ID} style={{ fontWeight: 400 }} href={`/fed/festivals/${itemD.festival.ID}`}>
                                        {itemD.festival.nazvanie}
                                        <div className="red-date" style={{ fontSize: (size === "medium" || size === "small") ? "12px" : "14px", display: "inline-block", padding: "0 5px", marginLeft: "3px", backgroundColor: "#0a00a5" }}>
                                            {true === sameDay(itemD.festival.dataNachala, itemD.festival.dataOkonchaniya) &&
                                                moment(itemD.festival.dataNachala).tz("Europe/Moscow").format('DD.MM.YYYY')
                                            }
                                            {true !== sameDay(itemD.festival.dataNachala, itemD.festival.dataOkonchaniya) &&
                                                <>
                                                    <span>{moment(itemD.festival.dataNachala).tz("Europe/Moscow").format('DD')}</span>
                                                    <span>-</span>
                                                    <span>{moment(itemD.festival.dataOkonchaniya).tz("Europe/Moscow").format('DD')}</span>
                                                    <span> {moment(itemD.festival.dataNachala).tz("Europe/Moscow").format('MMMM')} {moment(itemD.festival.dataNachala).tz("Europe/Moscow").format('YYYY')}</span>
                                                </>
                                            }
                                        </div>
                                    </a>
                                )
                            })}
                        </div>}
                    {(size !== "medium" && size !== "small") && <div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                        <span>Организатор: </span><span>{org(e)}</span>
                    </div>}
                    {(size !== "medium" && size !== "small") && <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                        <span>Уровень: </span><span>{e?.urovenMeropriyatiya?.opisanie}</span>
                    </div>}
                    <div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                        {(size === "large") ? <span>Место проведения: </span> : ""}
                        <span>{e?.mestoProvedeniya?.name}</span>
                    </div>
                    {(!hideKategorii && size !== "medium" && size !== "small") && kategoriiView(e)}
                    {((size !== "medium" && size !== "small") && e?.meropriyatieVSeriiMeropriyatie?.length > 0) &&
                        <div>
                            <div>Серии: </div>
                            <ul className="dotted" style={{ marginBottom: "7px" }}>
                                {JSXMap(e.meropriyatieVSeriiMeropriyatie, (meropriyatieVSerii) => (
                                    <li key={meropriyatieVSerii.ID}>
                                        <a href={`/fed/series/${meropriyatieVSerii.seriya.ID}`}>{meropriyatieVSerii.seriya.nazvanie}, сезон {meropriyatieVSerii.seriya.sezon.nazvanie}, этап {meropriyatieVSerii.etap}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>}

                    {!hideRoles && <div style={{ fontSize: "10px", display: "flex", flexWrap: "wrap", gap: (size === "large") ? "8px" : "1px 4px", padding: (size === "large") ? "10px 0px" : "1px 0px" }}>
                        {eventRoleOrganizer(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${e.ID}`} style={{ display: "flex", justifyContent: "space-between" }}>
                            <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Организатор</div>
                        </a>}
                        {eventRoleAdministrator(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${e.ID}`} style={{ display: "flex", justifyContent: "space-between" }}>
                            <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Администратор</div>
                        </a>}
                        {eventRoleControler(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/checkticket/${e.ID}`} style={{ display: "flex", justifyContent: "space-between" }}>
                            <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Контролер</div>
                        </a>}
                        {/* {eventRoleDancer(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}/event/${e.ID}/dancer`} style={{ display: "flex", justifyContent: "space-between" }}> */}
                        {eventRoleDancer(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Участник</div>}
                        {/* </a>} */}
                        {/* {eventRoleMainJudge(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}/event/${e.ID}/judge`} style={{ display: "flex", justifyContent: "space-between" }}> */}
                        {eventRoleMainJudge(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Главный судья</div>}
                        {/* </a>} */}
                        {/* {eventRoleJudge(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}/event/${e.ID}/judge`} style={{ display: "flex", justifyContent: "space-between" }}> */}
                        {eventRoleJudge(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Судья</div>}
                        {/* </a>} */}
                        {eventRoleSpecialguest(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Спец.гость</div>}
                        {/* {eventRolePresenter(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}/event/${e.ID}/presenter`} style={{ display: "flex", justifyContent: "space-between" }}> */}
                        {eventRolePresenter(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Ведущий</div>}
                        {/* </a>} */}
                        {/* {eventRoleDJ(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}/event/${e.ID}/dj`} style={{ display: "flex", justifyContent: "space-between" }}> */}
                        {eventRoleDJ(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Диджей</div>}
                        {/* </a>} */}
                        {/* {eventRoleViewer(e) && <a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}/event/${e.ID}/viewer`} style={{ display: "flex", justifyContent: "space-between" }}> */}
                        {eventRoleViewer(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Зритель</div>}
                        {/* </a>} */}
                        {eventRoleOperatorOBS(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Оператор OBS</div>}
                        {eventRoleChlenKomitetaPoSudeistvu(e) && <div className='bg bg-blue' style={{ maxWidth: "110px", height: "18px", minHeight: "auto" }}>Судейский комитет</div>}
                    </div>}
                    {extend && extend(size)}
                </div>
                {(buttons) && <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", gap: "10px", paddingTop: (size !== "medium" && size !== "small") ? "5px" : "0px" }}>
                    {buttons(size)}
                </div>}
                <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", gap: (size === "large") ? "7px" : "3px" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", gap: (size === "large") ? "7px" : "3px" }}>

                        {((!qr && !hideBuyButton) && dayjs().isBetween(e.nachaloRegistratsii, e.okonchanieSorevnovaniya, 'minute', '[]')) && <div>
                            <a
                                style={{ padding: (size === "medium" || size === "small") ? "4px 4px" : undefined, width: "100%", minWidth: (size !== "medium" && size !== "small") ? "92px" : "30px", fontSize: (size === "medium" || size === "small") ? "12px" : "14px" }}
                                className={`btn btn-primary btn-sm`}
                                href={`/app/pay/${e.ID}`}
                                target="_blank"
                                rel="noreferrer noopener">
                                {(size === "small") && <span><Icofont icon="cart" /></span>}
                                {(size === "medium") && <span><Icofont icon="cart" /> Купить</span>}
                                {(size === "large") && <span>Купить билет</span>}
                            </a>
                        </div>}

                        {qr && <div>
                            <Action
                                auth={auth}
                                action={() => {
                                }}
                                object={qr}
                                modal={{
                                    title: "Билет"
                                }}

                                readonly={true}
                                mode={"func"}
                                noAntForm={true}
                                form={(props) => {
                                    const { object } = props;
                                    return <div style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
                                        {object &&
                                            <div>
                                                <div style={{ textAlign: "center", padding: "0px 26px 0 26px" }}>
                                                    <div style={{ fontSize: "16px", fontWeight: "100" }}>Мероприятие</div>
                                                    <div style={{ fontSize: "22px", fontWeight: "600", lineHeight: "26px" }}>{e?.nazvanieMeropriyatiya}</div>
                                                    <div style={{ fontSize: "18px", fontWeight: "600", lineHeight: "26px" }}>г. {e?.mestoProvedeniya?.name}</div>
                                                    <div style={{ fontSize: "18px", fontWeight: "300", lineHeight: "26px" }}>{dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</div>
                                                </div>

                                                <div style={{ padding: "5px 5px 20px 5px", backgroundColor: "white", borderRadius: "6px", textAlign: "center" }}>
                                                    <QRCode level="M" value={object} />
                                                </div>

                                                {JSXMap(tickets, (t, idx) => {
                                                    return (<div key={idx} style={{ padding: "8px 6px" }}>
                                                        <div style={{ display: "flex" }}>
                                                            <div style={{ flex: "auto" }}>
                                                                <div style={{ fontWeight: "500" }}>
                                                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                        <div>{t.nazvanie}</div>
                                                                        <div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>
                                                                    </div>
                                                                </div>
                                                                {t.opisanie && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
                                                                    {t.opisanie}
                                                                </div>}
                                                                {JSXMap(t.yacheikaUsluga, (y, idx) => {
                                                                    return <div key={idx}>
                                                                        <div style={{ paddingLeft: "5px", fontSize: "13px" }}>
                                                                            {" - " + y.nazvanie}
                                                                            {(y.kategoriya) &&
                                                                                <span>
                                                                                    <span> - </span>
                                                                                    <span style={{ color: "#1890ff", fontStyle: "italic" }}>
                                                                                        {y.kategoriya.tantsevalnayaDistsiplina.nazvanie + " / " + y.kategoriya.kategoriyaUchastnikov.nazvanie}
                                                                                    </span>
                                                                                </span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                })}
                                                            </div>
                                                            <div>
                                                                <div style={{ alignSelf: "flex-start", color: "rgb(63, 134, 0)", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
                                                                    Оплачено:
                                                                </div>
                                                                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
                                                                    <div style={{ color: "rgb(63, 134, 0)" }}>{Number((t.summa).toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>)
                                                })}

                                                {JSXMap(eventUsers?.filter(x => x.eventUserTypeID != 3 && x.eventUserTypeID !== 8), (t, idx) => {
                                                    return (<div key={idx} style={{ padding: "8px 6px 15px 6px" }}>
                                                        <div style={{ display: "flex" }}>
                                                            <div style={{ flex: "auto" }}>
                                                                <div style={{ fontWeight: "500" }}>
                                                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                        <div>{t?.eventUserType?.description}</div>
                                                                        {/* <div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>)
                                                })}

                                                <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", gap: "5px" }}>
                                                    {((e?.eventUserMeropriyatie?.length > 0) && !!auth) && <div>
                                                        <a className='btn btn-success btn-sm' style={{ width: "100%", minWidth: "92px", fontSize: "14px" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${e.ID}`}>Войти в мероприятие</a>
                                                    </div>}
                                                    {(dayjs().isBetween(e.nachaloRegistratsii, e.okonchanieSorevnovaniya, 'minute', '[]')) && <div>
                                                        <a
                                                            style={{ width: "100%", minWidth: "92px", fontSize: "14px" }}
                                                            className={`btn btn-outline-primary btn-sm`}
                                                            href={`/app/pay/${e.ID}`}
                                                            target="_blank"
                                                            rel="noreferrer noopener">Купить ещё билет</a>
                                                    </div>}
                                                </div>
                                            </div>}
                                    </div>
                                }}
                                trigger={(click) => (
                                    <div onClick={event => {
                                        event.stopPropagation();
                                        click();
                                    }}
                                        style={{ padding: (size === "medium" || size === "small") ? "5px 7px" : undefined, width: "100%", minWidth: "92px", fontSize: (size === "medium" || size === "small") ? "12px" : "14px" }}
                                        className={`btn btn-outline-primary btn-sm`}>

                                        <i className="fa fa-qrcode" style={{ color: "black" }}></i> Билет
                                    </div>
                                )}
                            />
                        </div>}
                        {(adminButton /*|| isMyEvent(e, user, false) || hasActiveRight({ userID: user.ID, tipPolzovatelyaID: 30, meropriyatieID: e.ID }, user.vseTipiPolzovatelei) || isAnyAdministrator(user,e.ID)*/) && <div>
                            <a
                                style={{ padding: (size === "medium" || size === "small") ? "5px 7px" : undefined, width: "100%", minWidth: (size !== "medium" && size !== "small") ? "92px" : "30px", fontSize: (size === "medium" || size === "small") ? "12px" : "14px" }}
                                className={`btn btn-outline-danger btn-sm`}
                                href={_.isFunction(adminButton) ? adminButton() : `${path(pathname, 1)}/${e.ID}`}
                            // target="_blank"
                            // rel="noreferrer noopener"
                            >
                                {(size === "small") && <span><i className="fa fa-pencil-square-o"></i></span>}
                                {(size === "medium") && <span><i className="fa fa-pencil-square-o"></i> Изменить</span>}
                                {(size === "large") && <span><i className="fa fa-pencil-square-o"></i> Изменить</span>}

                            </a>
                        </div>}
                        {extButtons && extButtons({
                            style: { padding: (size === "medium" || size === "small") ? "5px 7px" : undefined, width: "100%", minWidth: (size !== "medium" && size !== "small") ? "92px" : "30px", fontSize: (size === "medium" || size === "small") ? "12px" : "14px" },
                            size,
                            path: (up) => path(pathname, up),
                        })}
                    </div>
                    {(size !== "small" && !hideDetailButton) && <div>
                        <a className={`btn btn-ghost-secondary ${(size === "medium" || size === "small") ? "" : "btn-pointer"} btn-sm`} style={{ padding: (size === "medium" || size === "small") ? "5px 7px" : undefined, fontSize: (size === "medium" || size === "small") ? "12px" : "14px", width: "100%" }} href={`/fed/event/${e.ID}`}>
                            {(size === "small") && <span><Icofont icon="arrow-right" /></span>}
                            {(size === "medium") && <span>Подробнее</span>}
                            {(size === "large") && <span>Подробнее</span>}
                        </a>
                    </div>}
                </div>
            </div>
        </div>
    )

}

